import { privacy, en } from "@/content";
import { useLang } from "@/lang";
import MacWindow from "@/components/MacWindow";
import Reveal, { MaskedLine } from "@/components/Reveal";

export default function Privacy() {
    const { lang } = useLang();
    const pv = lang === "en" ? en.privacy : privacy;
    return (
        <MacWindow id="privacy" testId="privacy-section" title={pv.windowTitle} icon="lock">
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.25em] text-ink/60">
                    {pv.overline}
                </p>
            </Reveal>
            <h2 className="mt-5 font-display text-4xl leading-[1.02] tracking-tight sm:text-5xl">
                <MaskedLine key={lang}>{pv.heading}</MaskedLine>
            </h2>
            <div className="mt-10 max-w-3xl">
                {pv.blocks.map((b, i) => (
                    <Reveal key={i} delay={0.05 * i}>
                        <div
                            data-testid={`privacy-block-${i}`}
                            className="border-t-2 border-ink py-6 last:border-b-2"
                        >
                            <h3 className="font-display text-xl tracking-tight md:text-2xl">
                                {b.title}
                            </h3>
                            <p className="mt-2 text-base leading-relaxed text-ink/80">
                                {b.text}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </MacWindow>
    );
}
